import { f as __read, g as __spread } from './chunk-525a49bc.js';
import ms from 'ms';

function clampNumber(v, minValue, maxValue) {
    return Math.max(Math.min(v, maxValue), minValue);
}
function sortStringsAlphabetically(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function getMiddlePixelsOfContainer(width, height, parentWidth, parentHeight) {
    return {
        sx: Math.floor((parentWidth - width) / 2),
        sy: Math.ceil((parentHeight - height) / 2),
        sw: width,
        sh: height,
        dx: Math.ceil((parentWidth - width) / 2),
        dy: Math.ceil((parentHeight - height) / 2),
        dw: width,
        dh: height,
    };
}
function getCanvas(img, width, height, cropSize) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext('2d');
    var fullContainer = {
        sx: 0,
        sy: 0,
        sw: canvas.width,
        sh: canvas.height,
        dx: 0,
        dy: 0,
        dw: canvas.width,
        dh: canvas.height,
    };
    var cropProps = cropSize
        ? getMiddlePixelsOfContainer(cropSize.width, cropSize.height, width, height)
        : fullContainer;
    if (ctx) {
        ctx.drawImage(img, cropProps.sx, cropProps.sy, cropProps.sw, cropProps.sh, cropProps.dx, cropProps.dy, cropProps.dw, cropProps.dh);
    }
    return canvas;
}
var shouldScaleYAxis = function (videoHeight, videoWidth, clientHeight, clientWidth) {
    var clientRatio = clientWidth / clientHeight;
    var videoRatio = videoWidth / videoHeight;
    return clientRatio < videoRatio;
};
var scaleDomToVideoResolution = function (videoHeight, videoWidth, sourceClientHeight, sourceClientWidth) {
    var isScalingYAxis = shouldScaleYAxis(videoHeight, videoWidth, sourceClientHeight, sourceClientWidth);
    var scaledClient = {
        clientHeight: sourceClientHeight,
        clientWidth: sourceClientWidth,
    };
    if (isScalingYAxis) {
        scaledClient.clientHeight = Math.round((sourceClientWidth * videoHeight) / videoWidth);
    }
    else {
        scaledClient.clientWidth = Math.round((videoWidth * sourceClientHeight) / videoHeight);
    }
    return scaledClient;
};
/**
 * Because the canvas uses the video resolution, we need to scale the clientPx to fit the videoPx
 * That way the users perception of the cropped area is the same as the actual cropping.
 */
var scaleCropSizeToVideoResolution = function (videoHeight, videoWidth, clientHeight, clientWidth, initialCropSize) {
    return initialCropSize
        ? {
            height: initialCropSize.height * (videoHeight / clientHeight),
            width: initialCropSize.width * (videoWidth / clientWidth),
        }
        : undefined;
};
function extractValidStrings(textAnnotations, maxLen, minLen) {
    if (textAnnotations === void 0) { textAnnotations = []; }
    if (maxLen === void 0) { maxLen = 20; }
    if (minLen === void 0) { minLen = 5; }
    var validStrings = textAnnotations
        .map(function (annotation) {
        return annotation.description ? annotation.description.trim() : '';
    })
        .filter(function (word) { return word.length > minLen && word.length < maxLen; });
    return __spread(new Set(validStrings));
}
function removeImageBase(imageString) {
    if (imageString === void 0) { imageString = ''; }
    var _a = __read(imageString.split(','), 2), base = _a[0], src = _a[1];
    return src || base;
}
function getGranularityInMS(granularity) {
    return ms(granularity);
}

export { scaleDomToVideoResolution as a, scaleCropSizeToVideoResolution as b, clampNumber as c, getGranularityInMS as d, extractValidStrings as e, getCanvas as g, removeImageBase as r, sortStringsAlphabetically as s };
